import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import PropTypes from "prop-types";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledTemplateLongDescription } from "./template-long-description.scss";
const TemplateLongDescription = ({ descriptions, translate })=>{
    const [readMore, setReadMore] = useState(false);
    if (!descriptions || descriptions.length === 0) return null;
    const firstParagraph = descriptions[0];
    const restParagraphs = descriptions.slice(1);
    const handleReadMoreClick = ()=>{
        setReadMore(true);
    };
    return /*#__PURE__*/ _jsxs(StyledTemplateLongDescription, {
        className: "template-long-description",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "template-description-main-title",
                children: translate("templateCenter.longDescription.title")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-paragraph-wrapper",
                children: firstParagraph === null || firstParagraph === void 0 ? void 0 : firstParagraph.paragraphContent
            }),
            !readMore && /*#__PURE__*/ _jsx("span", {
                className: "template-description-read-more",
                onClick: handleReadMoreClick,
                children: translate("templateCenter.longDescription.readMore")
            }),
            readMore && restParagraphs.length > 0 && restParagraphs.map((description, index)=>/*#__PURE__*/ _jsx("div", {
                    className: "template-paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx("div", {
                        children: description.paragraphContent
                    }, `description_${index}`)
                }))
        ]
    });
};
TemplateLongDescription.propTypes = {
    descriptions: PropTypes.arrayOf(PropTypes.shape({
        paragraphContent: PropTypes.string
    }))
};
TemplateLongDescription.defaultProps = {
    descriptions: []
};
export default withGenericConfig(TemplateLongDescription);
